import { Temporal } from "@js-temporal/polyfill";

export class BaseComponent {
    public ALL = 666; // For combo list non domain date only for display

    constructor() {}

    promptFile(x: any) {
        var url = window.URL.createObjectURL(x.body);
        var a = document.createElement('a');

        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
        if (matches != null && matches[1]) {
            a.download = matches[1].replace(/['"]/g, '');
        }

        a.href = url;
        // a.download = x.fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
    }

    convertTemporalToDate(tDate: Temporal.PlainDate) {
        return new Date(
            tDate.year,
            tDate.month - 1,
            tDate.day);
    }
}